import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  menu: {
    '.ant-menu-item-group-title': {
      padding: 0,
      marginBlock: 8
    },
    '.ant-menu-item': {
      paddingInline: '10px !important',
      marginBlock: '0 !important'
    }
  },
  popover: {
    '.ant-popover-inner': {
      padding: 16,
      paddingTop: 8,
      '.ant-menu-inline': {
        border: 'none'
      }
    },
    '.ant-menu-item-selected': {
      backgroundColor: token.lightGrey.lightGrey3
    }
  }
}))
